/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  UpdateMonitorMutationRequest,
  UpdateMonitorMutationResponse,
  UpdateMonitorPathParams,
  UpdateMonitor400,
  UpdateMonitor401,
  UpdateMonitor404,
} from '../types/UpdateMonitor.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getUpdateMonitorUrl(id: UpdateMonitorPathParams['id']) {
  const res = { method: 'PATCH', url: `/v1/monitors/${id}` as const };
  return res;
}

/**
 * @summary Update a monitor
 * {@link /v1/monitors/:id}
 */
export async function updateMonitor(
  id: UpdateMonitorPathParams['id'],
  data: UpdateMonitorMutationRequest,
  config: Partial<RequestConfig<UpdateMonitorMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UpdateMonitorMutationResponse,
    ResponseErrorConfig<UpdateMonitor400 | UpdateMonitor401 | UpdateMonitor404>,
    UpdateMonitorMutationRequest
  >({ method: 'PATCH', url: getUpdateMonitorUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
